





























































































import { Component, Vue, Ref } from 'vue-property-decorator'
import reg from './util/validate.js'
import UserModule from '@api/module/customer/user/UserModule'
import CommonModule from '@api/module/common/common/CommonModule'
import HomeModule from '@/portal/store/home/HomeModule'
import { LoginParams, AccountType } from '@packages/authentication'
import { WaitToRegisterAccount } from '@api/module/customer/user/models/WaitToRegisterAccount'
import ConfigCenterModule from '@api/module/common/config-center/ConfigCenterModule'
import LoginDialogModule from '@/portal/store/login/LoginDialogModule'
import { ElForm } from 'element-ui/types/form'
@Component
export default class extends Vue {
  validateRepeatPassword = (rule: any, value: any, callback: (error?: Error) => void) => {
    const reg = new RegExp('^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z\\W]{6,18}$')
    if (value === '') {
      callback(new Error('请重新输入密码'))
    } else if (value !== this.formData.password) {
      callback(new Error('两次输入密码不一致'))
    } else {
      reg.test(value) ? callback() : callback(new Error('请输入6-18位由数字和字母组合的密码'))
    }
  }

  show = false
  errText = ''
  // 验证码发送
  sending = false
  // 验证码返回的tokne
  ticket: any = null
  oldTicet: any = null
  // 预计倒计时时间
  count = 120
  // 发送后倒计时计时
  countTime = 120
  // 默认隐藏
  passwordState = false
  // 单位ID
  id = ''
  tokenPhone = ''
  loading = false
  validateToken = ''
  repeatPasswordState = false
  showClass = 'ico-pwd-show'
  hideClass = 'ico-pwd-hide'
  // 按钮灰
  btnDisabled = 'btn-disabled'
  // 注册方式
  registerType = 11
  // 注册来源
  sourceType = 1
  formData = {
    phoneNumber: '',
    password: '',
    phoneCaptcha: '',
    repeatPassword: ''
  }
  checked = true
  rules = {
    phoneNumber: [
      {
        required: true,
        message: '请输入正确的手机号',
        validator: reg.validatePhone,
        trigger: 'blur'
      }
    ],
    password: [
      {
        required: true,
        message: '请输入6-18位由数字和字母组合的密码',
        max: 18,
        min: 6,
        validator: reg.validatePassword,
        trigger: 'blur'
      }
    ],
    repeatPassword: [
      {
        required: true,
        max: 18,
        min: 6,
        validator: this.validateRepeatPassword,
        trigger: 'blur'
      }
    ],
    phoneCaptcha: [
      {
        required: true,
        message: '请输入短信验证码',
        trigger: 'blur'
      }
    ]
  }
  validateCodePic = ''

  change() {
    this.show = false
  }
  // 手机变化验证token失效
  changePhone() {
    if (this.formData.phoneNumber !== this.tokenPhone) {
      this.ticket = ''
    } else {
      this.ticket = this.oldTicet
    }
  }

  // 获取短信验证码
  async getPhoneCaptcha() {
    let phoneRse
    try {
      phoneRse = await UserModule.isPhoneNumberAccountExists(this.formData.phoneNumber)
      // console.log('phone', phoneRse)
    } catch (error) {
      console.log(error)
    }
    console.log(phoneRse)
    if (phoneRse?.data) {
      this.$message({
        type: 'warning',
        message: '该账号已注册'
      })
      return
    }
    // console.log(this.isPhoneNumber)
    if (!this.isPhoneNumber) return false
    if (!this.sending) {
      // 验证的手机号
      this.tokenPhone = this.formData.phoneNumber
      let res
      // 获取短信
      try {
        res = await CommonModule.applySMSVerificationCode(this.formData.phoneNumber)
        this.sending = true
        this.countDown(this.count)
      } catch (e) {
        console.log(e)
      }
      this.oldTicet = res?.data
      this.ticket = res?.data
    }
  }
  @Ref('form') form: ElForm
  // 注册
  async toRegister() {
    // 校验参数
    this.form.validate(async val => {
      if (val) {
        // 勾选详情
        if (!this.checked) {
          this.$message({
            type: 'warning',
            message: '请勾选服务条款'
          })
          return false
        }
        let phoneRse
        try {
          phoneRse = await UserModule.isPhoneNumberAccountExists(this.formData.phoneNumber)
        } catch (error) {
          console.log(error)
        }
        if (phoneRse?.data) {
          this.$message({
            type: 'warning',
            message: '该账号已注册'
          })
          return
        }
        // 短信码验证
        let validateToken
        const paylod = {
          ticket: this.ticket,
          smsCode: this.formData.phoneCaptcha
        }
        try {
          validateToken = await CommonModule.validateSMSCode(paylod)
        } catch (error) {
          console.log(error)
        }
        if (!validateToken?.data?.token) {
          this.errText = '短信验证码错误'
          this.show = true
          return
        }
        this.validateToken = validateToken?.data?.token
        // 表单检验后 发起请求
        const account = new WaitToRegisterAccount()
        account.phoneNumber = this.formData.phoneNumber
        account.registerType = this.registerType
        account.sourceType = this.sourceType
        account.password = this.formData.password
        account.nickName = this.formData.phoneNumber
        account.registerUnitId = this.id
        let result
        const paylodPrame = {
          captchaToken: this.validateToken,
          account: account
        }
        try {
          result = await UserModule.doRegisterUser(paylodPrame)
        } catch (error) {
          console.log(error)
          this.$message({
            type: 'warning',
            message: '注册失败~'
          })
        }
        if (result?.code !== 200) {
          this.errText = '注册失败'
          return false
        }
        // 注册成功后，提示注册成功，3秒后跳转到首页为已登录状态
        this.$message({
          message: '注册成功',
          type: 'success'
        })
        await this.login()
        // })
      } else {
        return false
      }
    })
  }
  async login() {
    console.log('进入登录流程')
    this.loading = true
    const loginParams = new LoginParams()
    loginParams.account = this.formData.phoneNumber
    loginParams.password = this.formData.password
    loginParams.longTerm = this.$authentication.rememberLoginInfo.longTerm
    loginParams.accountType = AccountType.customer
    this.loading = true
    try {
      const result = await this.$authentication.loginWithoutCaptcha(loginParams)
      if (result.status.code === 200) {
        try {
          await this.$authentication.auth()
          // this.stopTimerCount()
          this.$emit('login-result', true)
          this.toHome()
        } catch (e) {
          this.loading = false
        }
      } else {
        this.$message('自动登录失败~')
      }
    } catch (error) {
      this.$message('自动登录失败~')
    } finally {
      this.loading = false
    }
  }
  // 关闭
  clickClose() {
    LoginDialogModule.setShowRegisterDialog(false)
    this.$emit('registerClose')
  }
  toClause() {
    const { href } = this.$router.resolve({
      name: 'ServiceArticle'
    })
    window.open(href, '_blank')
    // this.clickClose()
  }
  changeRepeatPasswordState() {
    this.repeatPasswordState = !this.repeatPasswordState
  }
  changePasswordState() {
    this.passwordState = !this.passwordState
  }
  async refreshValidateCodePic() {
    const { data: captchaImg } = await this.$authentication.applyCaptcha()
    this.validateCodePic = `data:image/jpeg;base64,${captchaImg.b64Image}`
  }
  // 倒计时
  countDown(time: number) {
    let timer = time
    const timers = setInterval(() => {
      if (timer === 0) {
        clearInterval(timers)
        this.sending = false
        this.countTime = this.count
      } else {
        timer--
        this.countTime = timer
      }
    }, 1000)
  }
  goLogin() {
    this.$emit('go-login')
    LoginDialogModule.setShowLoginDialog(true)
    LoginDialogModule.setShowRegisterDialog(false)
  }
  toHome() {
    this.$emit('register-close')
    LoginDialogModule.setShowRegisterDialog(false)
    this.$router.replace('/')
  }

  async created() {
    await CommonModule.init()
    await HomeModule.init()
    const subUnitId = ConfigCenterModule.getApplicationByName('applicationDiff.Basicdata.subUnitId')
    await HomeModule.getCurrentUnitByDomain({
      domain: window.location.hostname,
      subUnitId: subUnitId
    })
    this.id = this.currentUnit?.id ? this.currentUnit?.id : ''
  }
  get isPhoneNumber() {
    const validate = /^[1]([3-9])[0-9]{9}$/.test(this.formData.phoneNumber)
    // console.log(validate)
    return validate
  }
  get currentUnit() {
    return HomeModule.currentUnit
  }
}
